export default __webpack_public_path__ + "static/media/36I-102728_-15729_0.3901d929.jpg";